import { ILoyaltyCustomer } from '../../interface/customer.interfaces';
import * as constants from './constants';

export function setIsLoyaltyProgramActive(value: boolean) {
  return { type: constants.SET_IS_LOYALTY_PROGRAM_ACTIVE, payload: value };
}

export function setIsAstrapayConnected(value: boolean) {
  return { type: constants.SET_IS_ASTRAPAY_CONNECTED, payload: value };
}

export function setAstrapointsValue(value: string) {
  return { type: constants.SET_ASTRAPPOINTS_VALUE, payload: value };
}

export function setAstrapayBalance(value: ILoyaltyCustomer) {
  return { type: constants.SET_ASTRAPAY_BALANCE, payload: value };
}
